// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 271 ? "page-gekko-ai" : chunkId) + "." + {"271":"5db092a3","506":"31d6cfe0"}[chunkId] + ".chunk.css";
};